import Vue from 'vue/dist/vue.esm';
import axios from 'common/axios';
import SetAndCreateForm from 'components/my_lists/set_and_create_form.vue';
import VueTextareaAutosize from 'vue-textarea-autosize';

document.addEventListener('DOMContentLoaded', () => {
  const currentUserId = JSON.parse(document.getElementById('my_list-new').dataset.currentUserId);
  const listableData = JSON.parse(document.getElementById('my_list-new').dataset.listableData);

  Vue.use(VueTextareaAutosize);

  new Vue({
    el: '#my_list-new',
    components: { SetAndCreateForm },
    data: {
      myLists: [],
      listableId: 0,
      addedMyListsSizeByListableId: {},
      wishListAdded: false,
      visibleForm: false,
      visibleNewMyListForm: false
    },
    computed: {
      currentUserId: function () {
        return currentUserId;
      },
      myListType: function () {
        return listableData.my_list_type;
      },
      listableType: function () {
        return listableData.listable_type;
      },
      targetAddedMyListPath: function() {
        return '/mypage/my_lists/target_added';
      }
    },
    watch: {
      addedMyListsSizeByListableId: function() {
        this.addedMyListsSize == 0 ? this.changeMyListAddedMark(false) : this.changeMyListAddedMark(true);
      }
    },
    mounted: function() {
      let links = document.querySelectorAll('.mylist--opener');
      links.forEach((link) => {
        link.addEventListener('click', this.showForm);
      });
    },
    methods: {
      loadAddedMyLists: async function(listableId) {
        await axios.get(this.targetAddedMyListPath, {
          params: {
            listable_id: listableId,
            listable_type: this.listableType
          }
        }).then(({ data }) => {
          this.addedMyListsSizeByListableId[listableId] = data.size;
        });
        this.onLoadAddedMyLists(listableId);
      },
      showForm: function(event) {
        event.stopPropagation();
        event.preventDefault();
        this.listableId = Number(event.currentTarget.dataset.listableId);
        this.wishListAdded = event.currentTarget.dataset.wishListed === 'true';
        this.visibleForm = true;
      },
      showNewMyListForm: function() {
        this.visibleNewMyListForm = true;
      },
      hideAllForm: function() {
        this.visibleForm = false;
        this.visibleNewMyListForm = false;
      },
      setMyLists: function(newMyLists) {
        this.myLists = newMyLists;
      },
      onLoadAddedMyLists: function(listableId) {
        this.addedMyListsSizeByListableId[listableId] == 0 ? this.changeMyListAddedMark(false, listableId) : this.changeMyListAddedMark(true, listableId);
      },
      changeMyListAddedMark: function(added, listableId) {
        document.querySelectorAll(`.mylist--opener[data-listable-id="${listableId}"]`)[0].dataset.listed = added;
      },
      markWishListAdded: function(listableId) {
        this.wishListAdded = true;
        document.querySelectorAll(`.mylist--opener[data-listable-id="${listableId}"]`)[0].dataset.wishListed = 'true';
      },
      markWishListRemoved: function(listableId) {
        this.wishListAdded = false;
        document.querySelectorAll(`.mylist--opener[data-listable-id="${listableId}"]`)[0].dataset.wishListed = 'false';
      }
    },
    template: `
      <div class="mylist--editor">
        <set-and-create-form
          :myListsFromParent='myLists'
          :currentUserId='currentUserId'
          :myListType='myListType'
          :listableId='listableId'
          :listableType='listableType'
          :visibleForm='visibleForm'
          :visibleNewMyListForm='visibleNewMyListForm'
          :wishListAdded='wishListAdded'
          @show-new-my-list-form='showNewMyListForm'
          @hide-all-form='hideAllForm'
          @set-my-lists='setMyLists'
          @load-added-my-lists='loadAddedMyLists'
          @wish-list-added='markWishListAdded'
          @wish-list-removed='markWishListRemoved'
        >
        </set-and-create-form>
      </div>
    `
  });
});
